export enum DataMode {
  readonly = 1,
  edition = 2,
}
